import { render } from "./create-role.vue?vue&type=template&id=1ac3f672&scoped=true"
import script from "./create-role.vue?vue&type=script&lang=js"
export * from "./create-role.vue?vue&type=script&lang=js"

import "./create-role.vue?vue&type=style&index=0&id=1ac3f672&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac3f672"]])

export default __exports__